var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgShareScreenDisable(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 45,
    height: 46,
    viewBox: "0 0 45 46",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_b_7315_480629)"
  }, /*#__PURE__*/React.createElement("rect", {
    y: 0.570312,
    width: 45,
    height: 45,
    rx: 22.5,
    fill: "black",
    fillOpacity: 0.15
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M29.25 17.4453H15.75C15.1287 17.4453 14.625 17.949 14.625 18.5703V27.5703C14.625 28.1916 15.1287 28.6953 15.75 28.6953H29.25C29.8713 28.6953 30.375 28.1916 30.375 27.5703V18.5703C30.375 17.949 29.8713 17.4453 29.25 17.4453ZM15.75 16.3203C14.5074 16.3203 13.5 17.3277 13.5 18.5703V27.5703C13.5 28.813 14.5074 29.8203 15.75 29.8203H29.25C30.4926 29.8203 31.5 28.813 31.5 27.5703V18.5703C31.5 17.3277 30.4926 16.3203 29.25 16.3203H15.75Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.2758 24.5703L18 23.4497L22.5 18.5703L27 23.4497L25.7242 24.5703L23.25 21.8875V27.5703H21.75L21.75 21.8875L19.2758 24.5703Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_b_7315_480629",
    x: -15,
    y: -14.4297,
    width: 75,
    height: 75,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    in: "BackgroundImageFix",
    stdDeviation: 7.5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "SourceAlpha",
    operator: "in",
    result: "effect1_backgroundBlur_7315_480629"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_backgroundBlur_7315_480629",
    result: "shape"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgShareScreenDisable);
export default __webpack_public_path__ + "static/media/shareScreenDisable.6e61b69e149f5431f7fed4841fcbf6d9.svg";
export { ForwardRef as ReactComponent };